import DiscussionDisable from 'pages/integrations/containers/DiscussionContainer/Components/discussionDisable';

const DiscussionIndex = () => {
  return <DiscussionDisable />;
};

export default DiscussionIndex;
